<template>
    <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900">Google Analytics</h3>
                <p class="mt-1 text-sm leading-5 text-gray-600">
                    Set up tracking for your board
                </p>
            </div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow overflow-hidden sm:rounded-md">
                <form @submit.prevent="submit">
                    <div class="px-4 py-5 bg-white sm:p-6">
                        <div class="grid grid-cols-6 gap-6">
                            <div class="col-span-6 sm:col-span-3">
                                <label for="ga_code" class="block text-sm font-medium leading-5 text-gray-700">
                                    Tracking ID
                                </label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <span class="text-gray-500 sm:text-sm">UA-</span>
                                    </div>
                                    <input type="text" id="ga_code" v-model="form.ga_tracking_id" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-8 sm:pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="1234-1">
                                </div>
                            </div>
                            <InputError :message="form.error('ga_tracking_id')" class="mt-2" />
                        </div>
                    </div>
                    <div class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6">
                        <ActionMessage :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </ActionMessage>

                        <Button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            Save
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Button from "@/Jetstream/Button";
    import ActionMessage from "@/Jetstream/ActionMessage";
    import InputError from "@/Jetstream/InputError";

    export default {
        name: "EditAnalytics",
        components: {
            Button,
            ActionMessage,
            InputError
        },
        props: {
            gaTrackingId: String,
            errors: Object
        },
        data() {
            return {
                form: this.$inertia.form({
                    ga_tracking_id: this.gaTrackingId || null
                }, {
                    resetOnSuccess: false
                })
            }
        },
        methods: {
            submit() {
                this.form.post('/settings/analytics', { preserveScroll: true });
            }
        }
    }
</script>
